export class SearchEnrolmentsRequestModel {
    StartDate: Date;
    EndDate: Date;
    InteractiveProgramStyleId: number;

    constructor() {
        this.InteractiveProgramStyleId = 0;
    }
}